import "./CompanyAvatar.scss"

import ColoredLetter from "@/shared/components/extrinsic/ColoredLetter/ColoredLetter"
import { classWithModifiers } from "@/utils/common"

interface CompanyAvatarProps {
  name: string,
  src?: string,
  imageAlt?: string,
  backgroundColor?: string
  letterColor?: string
}

export default function CompanyAvatar({ name, src, imageAlt = "Company logo", backgroundColor, letterColor }: CompanyAvatarProps) {
  const initialName = name ? name.charAt(0).toUpperCase() : ""
  const initialLetter = initialName.charAt(0).toUpperCase()


  return (
    <>
      {src ? <img className="company-avatar__image" src={src} alt={imageAlt} /> :
        <div className={classWithModifiers("company-avatar_letter-container")}>
          <ColoredLetter backgroundColor={backgroundColor} letterColor={letterColor} letter={initialLetter} />
        </div>
      }
    </>
  )
}
